<template>
    <div class="popup type2" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>의료진 검색</h2>
                    <button type="button" class="popup__close" @click="popupBtn"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <div class="info">
                        <div class="board__search">
                            <label class="board__input">
                                <input type="text" id="Search_doc" placeholder="검색어를 입력하세요." v-model="name" @input="viewList = doctorList.filter(i => {return i.name.includes(name)})">
                                <button type="button" class="board__input-btn"></button>
                            </label>
                        </div>
                    </div>
                    <!-- active : active -->
                    <ul class="doctor-list active">
                        <template v-for="doctor in viewList">
                            <li class="doctor-list__item" v-if="setViewList(doctor)">
                                <div class="doctor-list--img">
                                    <img :src="`/displayFile.do?attachNo=${doctor.attachBag.thumbs[0].attachNo}`" alt="이미지" v-if="doctor.attachBag.thumbs">
                                </div>
                                <div class="doctor-list--con">
                                    <div class="doctor-list--text">
                                        <h3 class="doctor-list--name">{{doctor.name}} 교수</h3>
                                        <p class="doctor-list--department">{{doctor.belong}}</p>

                                        <h4 class="doctor-list--clinic" v-if="doctor.detailField">전문진료분야</h4>
                                        <p class="doctor-list--desc">{{doctor.detailField}}</p>
                                    </div>
                                    <div class="doctor-list--button">
                                        <a href="javascript:;" @click="setDoctor(doctor)">해당 의료진 선택</a>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                popupShow: false,
                doctorList: [],
                viewList: [],
                name: '',
                refDoctorList: [],
            }
        },
        components: {
        },
        mounted() {
            this.getDoctorList()
        },
        methods: {
            popupBtn() {
                this.popupShow = !this.popupShow
            },
            getDoctorList(chosungs){
                const param = {
                    startIndex: 1,
                    name: '',
                    pageRow: 100,
                    langCd: this.$store.getters.getLang,
                    hospId: this.$store.getters.getHost,
                }
                this.axios.get(this.api.doctor.doctorList, {params: param})
                .then(res => {
                    if(res.data.doctorTotCnt > 0){
                        this.doctorList = res.data.doctorList
                        this.viewList = this.doctorList
                    }
                })
            },
            setDoctor(doctor){
                const drSid = doctor.drSid
                const deptCd = doctor.mainDeptCd
                const name = doctor.name
                const obj = {drSid: drSid, deptCd: deptCd, name: name}
                this.refDoctorList.push(obj)

                // 중복제거
                const dupSet = new Set();
                this.refDoctorList = this.refDoctorList.filter(i => {
                    const key = `${i.drSid}_${i.deptCd}`
                    if (!dupSet.has(key)) {
                        dupSet.add(key)
                        return true
                    }
                    return false
                })
                
                this.$emit('setParams', {refDoctorList: this.refDoctorList})
                this.popupShow = false
            },
            setViewList(doctor){
                const result = this.refDoctorList.some(i => i.drSid === doctor.drSid && i.deptCd === doctor.mainDeptCd)
                return !result
            }
        },
    }
</script>